"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var compareStudents = function compareStudents(a, b) {
  if (!a.familyName || !b.familyName) {
    throw new Error('All students require a familyName.');
  }

  if (!a.givenName || !b.givenName) {
    throw new Error('All students require a givenName.');
  }

  var aName = (a.familyName + a.givenName).toLowerCase();
  var bName = (b.familyName + b.givenName).toLowerCase();

  if (aName < bName) {
    return -1;
  } else if (aName > bName) {
    return 1;
  } else {
    return 0;
  }
};

var _default = function _default(listOfStudents) {
  if (!Array.isArray(listOfStudents)) {
    throw new Error('AmpApi: expected listOfStudents to be an array.');
  }

  return listOfStudents.sort(compareStudents);
};

exports["default"] = _default;